module.exports = __webpack_public_path__ + "81700ac2f89f30bdb03943d69c215167.svg";